export const soloVideos = [
  { id: 'HBQhYWrJNqo', name: 'Feeling All Right' },
  { id: 'ZKrT5jSm1f8', name: 'Dock of the Bay' },
  { id: 'oFj4KKZoPKk', name: 'Drift Away' },
  { id: 'vmwgXTOIkZg', name: 'Wake Me Up' },
  { id: 'aIkOkHGHjLc', name: 'All Along the Watchtower' },
  { id: '9qhA17UbOUc', name: 'On the Road Again' },
  { id: 'j5wBhSkLg0I', name: 'Stand by Me' },
  { id: 'nHoP7pllW0g', name: "Folsom Prison Blues @ Wegman's" },
  { id: 'GK0esUEYr0k', name: 'Wonderwall Jam' },
  { id: 'TJLztfCgz3U', name: 'Carry On (Original)' },
  { id: '12dKunwkxwU', name: 'She Talks to Angels' },
  { id: 'jyi8c25AZ2Q', name: 'Georgia on My Mind' },
  { id: 'sS68x81QL24', name: 'My Girl' },
  { id: 'rVoWkr7vhrc', name: 'Soul Food Sunday' },
  { id: 'JzHRuw5_t5g', name: "Like I'm Gonna Lose You" },
];

export const bandVideos = [
  { id: 'ZaRfGH4sO9o', name: 'Wagon Wheel' },
  { id: 'iYNo-NnYbtk', name: 'Dock of the Bay' },
  { id: '3Uj4Mx6eBIA', name: 'Folsom Prison Blues Jam' },
  { id: '8XJfpQINnR4', name: 'Hold My Hand Jam' },
];

export const audioTracks = [
  { id: 'nBgXj61eFcw', name: 'Carry On' },
  { id: 'Xp1BRnk7tEc', name: 'Change' },
  { id: 'GqriXW-ptqo', name: 'Blue Skies' },
  { id: 'N_cBP7_s8Gg', name: 'Pain in My Heart' },
  { id: 'x787TVg7b0c', name: 'Remember' },
  { id: 'Qa9FecWgh90', name: 'Thank You for the Love' },
  { id: 'mgbmgud6vSo', name: 'You Came to Me' },
  { id: 's-o2pGuzlbU', name: 'Little Wing' },
];
